import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import App from "./App";
import { Login } from "./pages/login/Login";
import ProtectedRoute from "./Routes/ProtectedRoute";

const AppWrapper = (props: any) => {

  // Get current location
  let location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />

      {/* All protected routes below */}
      <Route element={<ProtectedRoute />}>
        <Route path="*" element={<App />} />
      </Route>
    </Routes>
  );
};

export default AppWrapper;
